import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import Align from '@marvelapp/marvel-ui/align';
import Heading from '@marvelapp/marvel-ui/heading';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Spacing from '@marvelapp/marvel-ui/spacing';

import generalStyles from './style/general.module.css';
import alignStyles from './style/align.module.css';
import sizeStyles from './style/size.module.css';

const cx = classNames.bind({ ...alignStyles, ...sizeStyles, ...generalStyles });
const flexJustify = ['center', 'start', 'end', 'flexStart', 'spaceAround'];

export default function HeadingBlock({
  align,
  alignM,
  preChildren,
  children,
  color,
  copy,
  headingMaxWidth,
  headingSize,
  justify,
  justifyM,
  maxWidth,
  paragraphMaxWidth,
  paragraphSize,
  size,
  spacing,
  title,
  tag,
}) {
  const classes = cx(
    'headings',
    `alignItems-${justify}`,
    `justifyContent-${justify}`,
    `breakPointM-justifyContent-${justifyM}`,
    `breakPointM-alignItems-${justifyM}`,
    align
  );

  return (
    <div className={classes}>
      <div className={cx(size)}>
        <Align type={align} typeM={alignM}>
          <MaxWidth value={maxWidth} display="inlineBlock">
            {preChildren && preChildren}
            <MaxWidth value={headingMaxWidth} display="inlineBlock">
              <Heading
                tag={tag}
                color={color}
                size={headingSize}
                weight="semibold"
              >
                {title}
              </Heading>
            </MaxWidth>
            {copy && (
              <MaxWidth value={paragraphMaxWidth} display="inlineBlock">
                <Spacing type="margin" size="s" position="topBottom">
                  <Paragraph color={color} size={paragraphSize}>
                    {copy}
                  </Paragraph>
                </Spacing>
              </MaxWidth>
            )}
            {children && (
              <Spacing type="margin" size={spacing} position="topBottom">
                {children}
              </Spacing>
            )}
          </MaxWidth>
        </Align>
      </div>
    </div>
  );
}

HeadingBlock.propTypes = {
  align: PropTypes.oneOf(['left', 'center', 'right']),
  alignM: PropTypes.oneOf(['left', 'center', 'right']),
  children: PropTypes.node,
  preChildren: PropTypes.node,
  color: PropTypes.string,
  copy: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  headingMaxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  headingSize: PropTypes.oneOf([
    'xs',
    's',
    'm',
    'l',
    'xl',
    'xxl',
    'xxxl',
    'xxxxl',
  ]),
  justify: PropTypes.oneOf(flexJustify),
  justifyM: PropTypes.oneOf(flexJustify),
  maxWidth: PropTypes.number,
  paragraphMaxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  paragraphSize: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl', 'xxl']),
  size: PropTypes.oneOf(['xs', 's', 'm', 'l']),
  spacing: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  tag: PropTypes.oneOf(['h1', 'h2', 'h3']),
};

HeadingBlock.defaultProps = {
  align: 'center',
  alignM: 'left',
  headingMaxWidth: '100%',
  headingSize: 'xxxl',
  justify: 'center',
  justifyМ: 'start',
  maxWidth: undefined,
  paragraphMaxWidth: '100%',
  paragraphSize: 'l',
  size: 'm',
  spacing: 'l',
  tag: 'h2',
};



// WEBPACK FOOTER //
// ./src/components/modules/HeadingBlock/index.js